import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";

var _dec, _class, _class2, _temp;

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Dropzone from 'react-dropzone';
import { connect } from 'react-redux';

var twitterText = require('twitter-text');

import { Icon } from 'components';
import { replyToConversation, updateReplyText, uploadMedia, removeMedia } from 'redux/modules/messageCenter';
import * as styles from './TwitterReplyField.scss';
var TwitterReplyField = (_dec = connect(function (state) {
  return {
    organization: state.organization.current,
    theme: state.theme
  };
}, {
  replyToConversation: replyToConversation,
  updateReplyText: updateReplyText,
  uploadMedia: uploadMedia,
  removeMedia: removeMedia
}), _dec(_class = (_temp = _class2 = /*#__PURE__*/function (_Component) {
  _inherits(TwitterReplyField, _Component);

  var _super = _createSuper(TwitterReplyField);

  function TwitterReplyField(props) {
    var _this;

    _classCallCheck(this, TwitterReplyField);

    _this = _super.call(this, props);

    _defineProperty(_assertThisInitialized(_this), "getSocialAccount", function () {
      var _this$props = _this.props,
          organization = _this$props.organization,
          parent = _this$props.parent;
      var sa = false;

      if (parent.parentObjectId) {
        // if we have a parentObjectId, this will work
        organization.SocialAccounts.forEach(function (a) {
          if (a.platformId === parent.parentObjectId) {
            sa = a;
          }
        });
      } else {
        // otherwise, look through and find the FB page
        for (var i = 0; i < _this.props.organization.SocialAccounts.length; i++) {
          var a = _this.props.organization.SocialAccounts[i];

          if (a.platform === 'Facebook page') {
            sa = a;
          }
        }
      }

      return sa;
    });

    _defineProperty(_assertThisInitialized(_this), "handleCharCount", function (e) {
      var count = 140 - twitterText.getTweetLength(e.target.value);

      _this.setState({
        charCount: count
      });
    });

    _defineProperty(_assertThisInitialized(_this), "handleChange", function (e) {
      _this.setState({
        reply: e.target.value
      });

      _this.handleCharCount(e);

      if (_this.props.item && (_this.props.item.ConversationId || _this.props.item.parentMessageId)) {
        _this.props.updateReplyText(e.target.value, _this.props.conversationId, _this.props.item.id);
      } else if (_this.props.parent) {
        _this.props.updateReplyText(e.target.value, _this.props.conversationId);
      }
    });

    _defineProperty(_assertThisInitialized(_this), "handleDrop", function (files) {
      if (_this.props.item && (_this.props.item.ConversationId || _this.props.item.parentMessageId)) {
        _this.props.uploadMedia(files, _this.props.conversationId, _this.props.item.id);
      } else if (_this.props.parent) {
        _this.props.uploadMedia(files, _this.props.conversationId);
      }
    });

    _defineProperty(_assertThisInitialized(_this), "handleKeyDown", function (e) {
      if (e.key === 'Enter') {
        _this.handleSubmit();
      }
    });

    _defineProperty(_assertThisInitialized(_this), "handleSubmit", function () {
      var conversationId = _this.props.conversationId;
      var orgId = _this.props.organization.id;

      var socialAccountId = _this.props.organization.SocialAccounts.filter(function (a) {
        return a.platform === 'Twitter';
      })[0].id;

      var tweetId = _this.props.tweetId;
      var text = _this.state.reply;
      var reply = {
        text: text,
        authorSocialAccountId: socialAccountId
      };

      _this.props.replyToConversation(orgId, conversationId, reply);

      _this.props.closeField();
    });

    _this.state = {
      charCount: 140,
      reply: ''
    };
    return _this;
  }

  _createClass(TwitterReplyField, [{
    key: "render",
    value: function render() {
      var dropzoneRef;
      var _this$props2 = this.props,
          item = _this$props2.item,
          parent = _this$props2.parent;
      var replyText = (item ? item.replyText : this.props.parent.replyText) || '';
      console.log('in TwitterReplyField render');
      console.log(this.parent);
      return /*#__PURE__*/React.createElement("div", {
        className: styles.wrap,
        style: this.props.style
      }, /*#__PURE__*/React.createElement(Dropzone, {
        className: styles.dropzone,
        disableClick: true,
        disablePreview: true,
        multiple: false,
        onDrop: this.handleDrop,
        ref: function ref(node) {
          dropzoneRef = node;
        },
        style: {
          flex: '1 1 auto'
        }
      }, /*#__PURE__*/React.createElement("span", {
        className: styles.replyingTo
      }, /*#__PURE__*/React.createElement("span", {
        className: styles.gray
      }, "Replying to"), " @LikeableShane and @julians_sandbox"), /*#__PURE__*/React.createElement("div", {
        className: styles.inputWrap,
        style: {
          flex: '1 1 auto'
        }
      }, /*#__PURE__*/React.createElement("textarea", {
        className: styles.textField,
        onKeyDown: this.handleKeyDown,
        onChange: this.handleChange,
        value: this.state.reply,
        placeholder: "Tweet your reply"
      })), /*#__PURE__*/React.createElement("div", {
        className: styles.bottomRow
      }, /*#__PURE__*/React.createElement("span", {
        className: styles.imageUploadIcon,
        onClick: function onClick() {
          return dropzoneRef.open();
        }
      }, /*#__PURE__*/React.createElement(Icon, {
        name: "twitterImageUpload",
        color: "#0084B4",
        size: 24
      })), /*#__PURE__*/React.createElement("div", {
        style: {
          display: 'flex'
        }
      }, /*#__PURE__*/React.createElement("span", {
        className: styles.charCount,
        style: this.state.charCount < 0 ? {
          color: '#d40d12'
        } : {}
      }, this.state.charCount), /*#__PURE__*/React.createElement("span", {
        className: styles.btn,
        onClick: this.handleSubmit
      }, "Reply")))));
    }
  }]);

  return TwitterReplyField;
}(Component), _defineProperty(_class2, "propTypes", {
  item: PropTypes.any,
  parent: PropTypes.any,
  replyToConversation: PropTypes.func.isRequired
}), _temp)) || _class);
export default TwitterReplyField;